module.exports = __webpack_public_path__ + "media/details/expo@2x-cd44785e.png";